import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Details } from './components';
import useSchema from './useSchema';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const SchemaDetails = () => {
  const schema = useSchema();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Details schema={schema} showNav={true} next="/schema/design" />
      </div>
    </div>
  );
};

export default SchemaDetails;
